/**
 * 环境配置工具
 * 前后端同域部署，生产/UAT 构建使用同源相对路径，
 * 本地开发走 Vite 代理。
 */

export function getApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_API_BASE_URL || '/api'
  }
  return ''
}
